import { StepData } from '@frontend/design-system';
import { CareCreditCollectMultiSteps } from '../collect-multi-step.types';

export type CollectStepData = StepData & { id: CareCreditCollectMultiSteps };

export const getCollectSteps = (): CollectStepData[] => {
  const stepIds: { id: CareCreditCollectMultiSteps }[] = [
    {
      id: 'select-payment-method',
    },
    {
      id: 'payment-method-form',
    },
    {
      id: 'select-financing-option',
    },
    {
      id: 'receipt-options',
    },
  ];

  return stepIds.map((s) => {
    return {
      ...s,
      label: '', // set in specific steps and forced through CollectBaseStep
      isValid: false,
      isComplete: false,
      childSteps: [],
    };
  });
};
